import api from "./api";

const getUsers = async () => {

    const response = await api.get("/api/users");

    return response.data.data;

};

const addUser = async (userData) => {

    console.log(
        "Service User Data:",
        userData
    );

    const response = await api.post(
        "/api/user",
        userData,
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    );

    return response.data;
};

const addUserxxx = async(formData)=>{
	console.log("Service User Data:", formData);
    const response = await api.post(
        "/api/user",
        formData,
        {
            headers:{
                "Content-Type":"multipart/form-data"
            }
        }
    );

    return response.data;

}

const updateUser = async(id,formData)=>{

    const response = await api.put(
        `/api/users/${id}`,
        formData,
        {
            headers:{
                "Content-Type":"multipart/form-data"
            }
        }
    );

    return response.data;

}

const deleteUser = async(id)=>{

    const response = await api.delete(`/api/users/${id}`);

    return response.data;

}

export default{
    getUsers,
    addUser,
    updateUser,
    deleteUser
}